import { useState } from "react";
import { toast } from "sonner";
import { PaperPlaneTilt } from "@phosphor-icons/react";
import PageShell from "@/components/PageShell";
import PageMeta from "@/components/PageMeta";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.email || !form.message) return toast.error("Email and message are required");
    setSending(true);
    await new Promise((r) => setTimeout(r, 600));
    setSending(false);
    setForm({ name: "", email: "", message: "" });
    toast.success("Thanks! We'll get back to you soon.");
  };

  return (
    <PageShell
      eyebrow="Contact"
      title="Say hello."
      subtitle="Have a question, a partnership, or a bug to report? Drop us a line — we read everything."
      narrow
    >
      <PageMeta
        title="Contact SendMe"
        description="Get in touch with SendMe — hello@sendme.co.in for general questions, support@sendme.co.in for tech support, security@sendme.co.in for vulnerability reports."
      />
      <div className="grid md:grid-cols-[1.2fr_1fr] gap-10">
        <form onSubmit={submit} className="brut-card p-6 space-y-5" data-testid="contact-form">
          <div>
            <div className="small-caps mb-2">Name</div>
            <input
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              className="input-brut w-full"
              data-testid="contact-name"
              placeholder="Ada Lovelace"
            />
          </div>
          <div>
            <div className="small-caps mb-2">Email</div>
            <input
              type="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="input-brut w-full"
              data-testid="contact-email"
              placeholder="you@domain.com"
              required
            />
          </div>
          <div>
            <div className="small-caps mb-2">Message</div>
            <textarea
              value={form.message}
              onChange={(e) => setForm({ ...form, message: e.target.value })}
              className="input-brut w-full min-h-[140px] resize-vertical"
              data-testid="contact-message"
              placeholder="What's up?"
              required
            />
          </div>
          <button type="submit" disabled={sending} data-testid="contact-submit" className="btn-brut-primary">
            <PaperPlaneTilt size={18}/> {sending ? "Sending…" : "Send message"}
          </button>
        </form>
        <aside className="space-y-4">
          <div className="brut-card p-5">
            <div className="small-caps mb-2">Email</div>
            <div className="font-mono">hello@sendme.co.in</div>
          </div>
          <div className="brut-card p-5">
            <div className="small-caps mb-2">Support hours</div>
            <div className="font-mono">Mon–Fri · 9am–6pm UTC</div>
          </div>
          <div className="brut-card p-5">
            <div className="small-caps mb-2">Press</div>
            <div className="font-mono">press@sendme.co.in</div>
          </div>
        </aside>
      </div>
    </PageShell>
  );
}
